import { z } from 'zod';

/**
 * URL search-parameter schema for the `/api-keys` route.
 *
 * Mirrors `features/settings/search-schema.ts`'s `?dialog=` convention: the
 * create dialog's open state lives in the URL (not local `useState`), so a
 * refresh keeps it open, the back button closes it, and the command palette's
 * "Create API key" quick action can open it by navigating here with
 * `?dialog=create` instead of forking a second copy of `CreateApiKeyDialog`.
 *
 * `.catch(undefined)` so a stale/hand-edited URL degrades to "no dialog"
 * rather than throwing a ZodError out of `validateSearch`.
 */
export const API_KEYS_DIALOGS = ['create'] as const;
export type ApiKeysDialog = (typeof API_KEYS_DIALOGS)[number];

export const apiKeysSearchSchema = z.object({
  dialog: z.enum(API_KEYS_DIALOGS).optional().catch(undefined),
});

export type ApiKeysSearch = z.infer<typeof apiKeysSearchSchema>;
